module.exports = __webpack_public_path__ + "img/ic_select.0866a64e.svg";